import { TableFilterDisplay } from '@app/modules/table/types/table-filter-display.type';
import { isNil } from 'lodash-es';
import { SelectFilterOption } from '../../interfaces/select-filter-option.interface';
import { Filter } from '../filter.abstract';
import { TableFilter } from './table-filter.abstract';

export const isSelectFilter = (filter: Filter): filter is SelectFilter => filter.type === 'select';

export interface SelectFilterConfig {
    initialSelection?: SelectFilterOption;
    placeholder?: string;
    nullable?: boolean;
}

export class SelectFilter extends TableFilter {
    type: TableFilterDisplay = 'select';
    selected: SelectFilterOption = null;
    options: SelectFilterOption[] = [];
    placeholder: string;
    nullable = true;

    constructor(
        protected filterField: string,
        options: SelectFilterOption[] | Promise<SelectFilterOption[]>,
        configOptions?: SelectFilterConfig
    ) {
        super();

        const { initialSelection, placeholder, nullable } = configOptions;

        this.placeholder = placeholder;
        this.label = placeholder;

        if (typeof nullable !== 'undefined') {
            this.nullable = nullable;
        }

        options = Promise.resolve(options);
        options.then((resolvedOptions: SelectFilterOption[]) => {
            this.options = resolvedOptions;

            if (configOptions.initialSelection) {
                this.selected = this.options.find(
                    (option: SelectFilterOption) => initialSelection.value === option.value
                );
                this.emitValueChange();
            }

            this.isReady = true;
        });
    }

    changeValue(option: SelectFilterOption): void {
        this.selected = option;
        this.emitValueChange();
    }

    hasValues(): boolean {
        return this.selected && !isNil(this.selected.value);
    }

    isClearable(): boolean {
        return this.nullable && this.hasValues();
    }

    clear(): void {
        if (!this.nullable) {
            return;
        }

        this.selected = null;
        this.emitValueChange();
    }

    protected emitValueChange(): void {
        this.onChanges.next([{ field: this.filterField, value: this.selected?.value }]);
    }
}
